import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

const Div = styled.div`
  font-family: Alegreya, serif;
  font-weight: normal;
  position: absolute;
  text-align: left;
  opacity: 1;
  padding: 20px;
  z-index: 1000;

  @media (max-width: 600px) {
    display: block !important;
    top: 50px;
  }

  .auto-grid {
    grid-column-start: 2;
    grid-row-start: 3;
  }

  h3 {
    font-size: 1.25em;
    font-weight: 400;
    margin: 0 0 8px;

    @media (min-width: 480px) {
      font-size: 2.25em;
    }
  }

  p {
    font-size: 1em;
    line-height: 1.3em;
    margin: 0 0 .5em;

    @media (min-width: 480px) {
      font-size: 1.5em;
    }
  }
`;

const Overview = ({ title, copy, overviewPosition, overviewColor, overviewEnabled }) => {

  const position = overviewPosition && {
    display: 'grid',
    height: '100%',
    width: '100%',
    gridTemplateColumns: `${ overviewPosition.left } auto ${ overviewPosition.right }`,
    gridTemplateRows: `100px ${ overviewPosition.top } auto ${ overviewPosition.bottom }`,
  };

  const alignment = overviewPosition && {
    justifySelf: overviewPosition.justifySelf,
    alignSelf: overviewPosition.alignSelf
  };

  return overviewEnabled ?
        <Div style={ position } className="overview">
          <div style={ alignment } className="auto-grid">
            <h3 style={ { color: overviewColor } }>{ title }</h3>
            <p style={ { color: overviewColor } }>{ copy }</p>
          </div>
        </Div> : null;
};

Overview.propTypes = {
  title: PropTypes.string,
  copy: PropTypes.string,
  overviewPosition: PropTypes.object,
  overviewColor: PropTypes.string,
  overviewEnabled: PropTypes.bool
};

export default Overview;



// WEBPACK FOOTER //
// ./src/components/Overview/index.js